export default __webpack_public_path__ + "static/media/08_FOLORN.338a1215.png";